import React from "react";
import { useRoutes } from "react-router-dom";
import App from "./App";
import ErrorPage from "./pages/ErrorPage";
import TablePage from "./pages/TablePage";

export default function Routes() {
  const routes = useRoutes([
    {
      path: "/",
      element: <App />,
      errorElement: <ErrorPage />,
    },
    {
      path: "/table",
      element: <TablePage />,
    },
    {
      path: "*",
      element: <ErrorPage />,
    },
  ]);
  return routes;
}
